import { z } from 'zod';
import i18n from '@/i18n';

export const registrationStepFiveSchema = z.object({
    // @ts-ignore
    gender: z.enum(['male', 'female'], { message: i18n.t('gender_required') }),
    // @ts-ignore
    looks_for: z.enum(['male', 'female', 'any'], { message: i18n.t('gender_required') }),
    min_age: z.number(),
    max_age: z.number(),
});

export type RegistrationStepFiveType = z.infer<typeof registrationStepFiveSchema>;
